function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Box from './Box';
import useBodyLockScroll from './hooks/useBodyLockScroll';
export const Backdrop = /*#__PURE__*/React.forwardRef((props, ref) => {
  useBodyLockScroll(props.skipBodyLock);
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    variant: "backdrop"
  }, props));
});
Backdrop.displayName = 'Backdrop';
export default Backdrop;